module.exports = __webpack_public_path__ + "fonts/NotoSans-Regular.0589d1a2.eot";